import { PlayerUtilitiesService } from './../../players/services/player-utilities.service';
import { User } from './../../models/user';
import { AuthFacade } from './../../auth/state/auth.facade';
import { Match } from './../../models/match';
import { Injectable } from '@angular/core';
import { Observable, from, combineLatest, of } from 'rxjs';
import { map, take, mergeMap, toArray } from 'rxjs/operators';
import { ResourceLoadResponse } from '../../shared/state';

@Injectable()
export class MatchUtilitiesService {
	constructor(private authFacade: AuthFacade, private playerUtilitiesService: PlayerUtilitiesService) {

	}

	public mapArrayAsObservable(matches: ResourceLoadResponse<Match>): Observable<ResourceLoadResponse<Match>> {
		return this.authFacade.currentUser$.pipe(
			take(1),
			mergeMap(currentUser =>
				from(matches.results).pipe(
					mergeMap(item => this.map(item, currentUser)),
					toArray(),
					map(arr => ({
						total: matches.total,
						results: [...arr]
					} as ResourceLoadResponse<Match>))
				),
			),
		);
	}

	public mapAsObservable(match: Match, isTournamentContext = false): Observable<Match> {
		return this.authFacade.currentUser$.pipe(
			take(1),
			mergeMap(currentUser => this.map(match, currentUser, isTournamentContext))
		);
	}

	public map(match: Match, currentUser: User, isTournamentContext = false): Observable<Match> {
		return combineLatest([
			of(match),
			this.playerUtilitiesService.mapAsObservable(match.challenger, isTournamentContext),
			this.playerUtilitiesService.mapAsObservable(match.challenged, isTournamentContext),
			this.playerUtilitiesService.mapAsObservable(currentUser)
		]).pipe(
			map(([match, challenger, challenged, me]) => {
				match.challenger = challenger;
				match.challenged = challenged;

				if (me.id === match.challengerId || me.id === match.challengedId) {
					match.me = me;
				}

				if (me.id === match.challengerId) {
					match.myScore = match.scoreChallenger;
					match.opponentScore = match.scoreChallenged;
					match.opponent = match.challenged;
				} else if (me.id === match.challengedId) {
					match.myScore = match.scoreChallenged;
					match.opponentScore = match.scoreChallenger;
					match.opponent = match.challenger;
				}

				return match;
			})
		)
	}
}
